import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomSnackbarService } from '../../custom-notification/custom-notification.component';
import { ProductListingService } from 'src/app/service/product-listing.service';

@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.css']
})
export class AddServiceComponent {
  form!: FormGroup;

  constructor(private fb: FormBuilder, private productListingService: ProductListingService, private customSnackbarService: CustomSnackbarService) { }

  @Input() formTitle: string = '';
  @Output() resetListing = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryVarientList: any = {
    loading: false,
    response: null,
    error: ''
  };
  servTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  statusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  serviceDurationList: any = {
    loading: false,
    response: null,
    error: ''
  };
  appointmentList: any = {
    loading: false,
    response: [
      { id: 'Y', name: 'Yes' },
      { id: 'N', name: 'No' }
    ],
    error: ''
  };
  allowedFileSizeToUpload: number = 2; //size in MB
  uploadingFile: boolean = false;
  submitLoading: boolean = false;
  uploadingMediaIndex:number|null=null;
  ngOnInit() {
    this.form = this.fb.group({
      type: "SERVICE",
      id: [null],
      productId: [null],
      productName: ['', [Validators.required, Validators.maxLength(64)]],
      description: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(1)]],
      categoryId: ['', Validators.required],
      subCategoryId: ['', Validators.required],
      discountedPrice: ['', this.discPriceCantMoreThanPrice],
      statusId: ['', Validators.required],
      appointmentFlag: [''],
      requirement: [""],
      mediaList: this.fb.array([this.fb.control("", Validators.required), this.fb.control(""), this.fb.control(""), this.fb.control("")]),
      serviceTypes: ['', Validators.required],
      variantOption1: [null],
      // variantOption2: [null],
      // variantOption3: [null],
    });
    const priceControl = this.form?.get('price');
    if (priceControl) {
      priceControl.valueChanges.subscribe(() => {
        const discountedPriceControl = this.form.get('discountedPrice');
        if (discountedPriceControl) {
          // Clear the value of discountedPrice when price changes
          discountedPriceControl.setValue(discountedPriceControl.value);
          discountedPriceControl.updateValueAndValidity();
        }
      });
    }
    this.getProductCategories()
    this.form.get('categoryId')?.valueChanges.subscribe(newCategoryValue => {
      // Handle changes here
      this.form.get('subCategoryId')?.setValue('')
      this.subCategoryVarientList = {
        loading: false,
        response: null,
        error: ''
      }
      this.getSubCategories(newCategoryValue)
    });
    this.getServiceType()
    this.getProductStatus()
    this.getServiceDurationList()
  }

  discPriceCantMoreThanPrice(control: any) {
    const value = control.value;
    // Check if the value is greater than 0
    if (value && Number(control?._parent?.value?.price) <= Number(value)) {
      return { moreThanPrice: true };
    }
    return null;
  }
  // Convenience getters for easy access to form arrays and controls
  get mediaList(): FormArray {
    return this.form.get('mediaList') as FormArray;
  }

  removeMedia(mediaIndex: number) {
    // this.mediaList.removeAt(index);
    if (mediaIndex >= 0 && mediaIndex <= this.mediaList.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue("");
    }
  }

  allowOnlyNumeric(event: KeyboardEvent) {
    // Allow backspace
    if (event.key === 'Backspace') {
      return true;
    }

    // Allow only numeric digits
    const isNumeric = /^\d$/.test(event.key);

    if (!isNumeric) {
      event.preventDefault();
      return false;
    }

    return true; // This line is necessary for TypeScript to be satisfied
  }

  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  getProductStatus() {
    this.statusList = {
      ...this.statusList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductStatus().then((res: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getServiceDurationList() {
    this.serviceDurationList = {
      ...this.serviceDurationList,
      loading: true,
      error: ''
    }
    this.productListingService.getServiceDuration().then((res: any) => {
      this.serviceDurationList = {
        ...this.serviceDurationList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.serviceDurationList = {
        ...this.serviceDurationList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategories(catId: string) {
    if (!catId) {
      return
    }
    this.subCategoryList = {
      ...this.subCategoryList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getProductSubCategories(catId).then((res: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  handleReset() {
    // this.form.reset();
    // (this.form.get('mediaList') as FormArray).push(this.fb.control("", Validators.required));
    this.close.emit()
  }


  getServiceType() {
    this.servTypeList = {
      ...this.servTypeList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getServiceType().then((res: any) => {
      this.servTypeList = {
        ...this.servTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.servTypeList = {
        ...this.servTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  get mediaListt() {
    return (this.form.get('mediaList') as FormArray).controls;
  }
  addMediaAtIndex(mediaIndex: number, updatedObject: any) {
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue(updatedObject);
    }
  }
  uploadFile(value: any, type: string, index: number) {
    const selectedFile = value.files[0];
    const maxSizeInBytes = this.allowedFileSizeToUpload * 1024 * 1024; // 2MB (adjust to your maximum size)
    if (selectedFile.type === "image/png" || selectedFile.type === "image/jpg" || selectedFile.type === "image/jpeg") {

      if (selectedFile && selectedFile.size > maxSizeInBytes) {
        this.customSnackbarService.openCustomSnackbar(`File size must be less than ${this.allowedFileSizeToUpload} MB`, 30000, true);
        return
      }
      this.uploadingMediaIndex = index;
      this.uploadingFile = true;
      let formData: FormData = new FormData();
      formData.append('files', value.files[0]);
      formData.append('type', 'ProductMedia')

      this.productListingService.uploadFile(formData).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          if (type === "media") {
            this.addMediaAtIndex(index, { src: res.data.data.documentUri })
          }
          this.uploadingFile = false;
          this.uploadingMediaIndex = null;
        }
      }).catch((error: any) => {
        this.uploadingMediaIndex = null;
        this.uploadingFile = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      this.customSnackbarService.openCustomSnackbar('Only accept .png, .jpg, .jpeg', 30000, true);

    }
  }

  onSubmit() {
    if(this.submitLoading || this.uploadingFile){
      return
    }
    if (this.form.valid) {
      // Handle form submission logic here
      this.submitLoading = true; 
      this.form.value.mediaList = this.form.value.mediaList.filter((l:any)=>l)
      this.productListingService.saveProduct(this.form.value).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          this.resetListing.emit()
          this.submitLoading = false;
          this.customSnackbarService.openCustomSnackbar('The service has been added successfully.', 30000);
        }
      }).catch((error: any) => {
        console.log(error, 'ddd')
        this.submitLoading = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      console.log(this.form);
      // Mark all controls as touched to display validation messages
      this.form.markAllAsTouched();
    }
  }
}
